import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import { LIVE_EVENT_DATA_SPORT_TYPES } from '@utils/formatters/common'
import useScoreboard from '@hooks/useScoreboard'

import ScoreboardGoalContentSection from './ScoreboardGoalContentSection'
import ScoreboardMatchResultHockey from './ScoreboardMatchResultHockey'
import ScoreboardMatchResultSoccer from './ScoreboardMatchResultSoccer'
import ScoreboardMatchStatus from './ScoreboardMatchStatus'
import ScoreboardTeam from './ScoreboardTeam'

const StyledScoreboardMatchResult = styled.div`
  ${({
    theme: {
      spacing: { spacing16 },
    },
  }) => css`
    align-items: center;
    display: flex;
    flex-direction: column;
    margin: 0 ${spacing16};
  `}
`

const StyledScoreboardWrapper = styled.div`
  width: 100%;
`

const MainContentWrapper = styled.div`
  display: grid;
  grid-auto-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  grid-auto-flow: column;
`
const ScoreboardHockeyOrSoccer: FunctionComponent = () => {
  const { sportsEventType } = useScoreboard<
    | typeof LIVE_EVENT_DATA_SPORT_TYPES.SOCCER
    | typeof LIVE_EVENT_DATA_SPORT_TYPES.HOCKEY
  >()

  let ScoreboardMatchResultComponent = null

  if (sportsEventType === LIVE_EVENT_DATA_SPORT_TYPES.SOCCER) {
    ScoreboardMatchResultComponent = <ScoreboardMatchResultSoccer />
  } else if (sportsEventType === LIVE_EVENT_DATA_SPORT_TYPES.HOCKEY) {
    ScoreboardMatchResultComponent = <ScoreboardMatchResultHockey />
  }

  return (
    <StyledScoreboardWrapper>
      <MainContentWrapper>
        <ScoreboardTeam />
        <StyledScoreboardMatchResult>
          <ScoreboardMatchStatus />
          {ScoreboardMatchResultComponent}
        </StyledScoreboardMatchResult>
        <ScoreboardTeam isAwayTeam />
      </MainContentWrapper>
      <ScoreboardGoalContentSection />
    </StyledScoreboardWrapper>
  )
}

export default ScoreboardHockeyOrSoccer
